import { Tooltip } from '@mui/material'
import { Icon } from '../Layout/Icon'

type ChatMode = 'popup' | 'sidebar' | 'chat'

interface AiChatHeaderProps {
  mode: ChatMode
  onClose: () => void
  onSwitchMode: (mode: ChatMode) => void
  onReset: () => void
}

export function AiChatHeader({ mode, onClose, onSwitchMode, onReset }: AiChatHeaderProps) {
  return (
    <div className='flex flex-shrink-0 items-center justify-between border-b border-light-dark-gray bg-pure-white px-4 py-3'>
      <div className='flex items-center gap-1'>
        <Tooltip title='Minimize'>
          <button type='button' onClick={onClose} className='rounded p-1 hover:bg-lightest-gray'>
            <Icon
              name='remove'
              className='text-xl text-medium-dark-gray hover:text-bright-templi-purple'
            />
          </button>
        </Tooltip>

        {mode !== 'popup' && (
          <Tooltip title='Popup'>
            <button
              type='button'
              onClick={() => onSwitchMode('popup')}
              className='hidden md:block rounded p-1 hover:bg-lightest-gray'
            >
              <Icon
                name='chat_bubble_outline'
                className='text-xl text-medium-dark-gray hover:text-bright-templi-purple'
              />
            </button>
          </Tooltip>
        )}

        {mode !== 'sidebar' && (
          <Tooltip title='Sidebar'>
            <button
              type='button'
              onClick={() => onSwitchMode('sidebar')}
              className='hidden md:block rounded p-1 hover:bg-lightest-gray'
            >
              <Icon
                name='dock_to_right'
                className='text-xl text-medium-dark-gray hover:text-bright-templi-purple'
              />
            </button>
          </Tooltip>
        )}

        {mode !== 'chat' && (
          <Tooltip title='Maximize'>
            <button
              type='button'
              onClick={() => onSwitchMode('chat')}
              className='rounded p-1 hover:bg-lightest-gray'
            >
              <Icon
                name='open_in_full'
                className='text-xl text-medium-dark-gray hover:text-bright-templi-purple'
              />
            </button>
          </Tooltip>
        )}
      </div>

      <span className='text-xl font-bold md:pr-9'>Chat</span>

      <Tooltip title='Restart session'>
        <button type='button' onClick={onReset} className='rounded p-1 hover:bg-lightest-gray'>
          <Icon
            name='restart_alt'
            className='text-2xl text-medium-dark-gray hover:text-bright-templi-purple'
          />
        </button>
      </Tooltip>
    </div>
  )
}
